<script setup lang="ts">
/**
 * UI-kit component
 * Category: 'Kanban components'
 * Name: 'Priority'
 * FIGMA: 'https://www.figma.com/design/oRsJUOAucnhxx5aeqy4TRO/APP-admin?node-id=13714-256704&t=6CTl5z4NeoYM2d97-4'
 */
import type { KanbanPriorityProps } from '../types/interfaces'

import { faFlagPennant } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { IconContainer } from '@shared/ui/other'

import { useKanbanPriority } from '../composables/use-kanban-priority.hook'

defineOptions({
  name: 'KanbanPriority',
})

const props = withDefaults(defineProps<KanbanPriorityProps>(), {
  size: 'small',
})

const {
  refPriorityLabel,
} = useKanbanPriority({ props })
</script>

<template>
  <span
    v-if="refPriorityLabel"
    :class="['kanban-priority', size]"
  >
    <IconContainer
      :class="['kanban-priority__icon', `kanban-priority__icon--${refPriorityLabel.toLowerCase()}`]"
    >
      <FontAwesomeIcon :icon="faFlagPennant" />
    </IconContainer>
    <span>{{ refPriorityLabel }}</span>
  </span>
</template>

<style lang="scss" scoped src="../styles/_kanban-priority.scss" />
